export default {
      id: "small-close-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-close",
      toString: function () {
        return this.url;
      }
    }